import React from "react";
import downArrow from "src/assets/down-arrow.svg";

interface OrderStatusProps {
  orderStatusCode: number;
  orderStatusText: string;
}

export const ORDER_STATUS_MAP = [
  {
    status_id: [15, 16, 31, 32, 35, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 7, 14],
    status: "rejected",
    32: { bgColor: "#FBEEEE", textColor: "#A92626" },
  },
  { status_id: [4], status: "cancelled", bgColor: "#FBEEEE", textColor: "#A92626" },
  { status_id: [0, 3, 1], status: "completed", bgColor: "#D3F6E4", textColor: "#207A65" },
  {
    status_id: [5, 30, 33, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47],
    status: "approval",
    37: { bgColor: "#FFF9ED", textColor: "#996B0F" },
  },
  { status_id: [18], status: "escalated", bgColor: "#FFF1F3", textColor: "#661F28" },
  { status_id: [2, 3], status: "invoiced", 2: { bgColor: "#FBEEEE", textColor: "#A92626" } },
];

const getStatusColors = (orderStatusCode: number): { bgColor: string; textColor: string } => {
  for (const group of ORDER_STATUS_MAP) {
    if (group.status_id.includes(orderStatusCode)) {
      if (group.hasOwnProperty(orderStatusCode)) {
        return (group as any)[orderStatusCode];
      }
      // Use group default if defined
      if (group.bgColor && group.textColor) {
        return { bgColor: group.bgColor, textColor: group.textColor };
      }
    }
  }
  // Fallback style
  return { bgColor: "#f1f1f1", textColor: "black" };
};

const OrderStatusTooltip: React.FC<OrderStatusProps> = ({ orderStatusCode, orderStatusText }) => {
  const { bgColor, textColor } = getStatusColors(orderStatusCode);

  return (
    <div>
      <p
        className="font-semibold flex items-center w-fit mt-0 text-[.8rem] h-6 px-2 rounded-full"
        style={{ backgroundColor: bgColor, color: textColor }}
      >
        {orderStatusText || "Pending"}
        <img src={downArrow} alt="down-arrow" className="w-4 h-4 ml-1" />
      </p>
    </div>
  );
};

export default OrderStatusTooltip;
